
const train = document.querySelector('.footer__animated-image');
const startPosition = '1';
const endPosition = '100';

if (train) {
    const driveUp = e => {
        if (e && e.propertyName !== 'transform') return;
        train.style.setProperty('--train-position', endPosition);
        train.removeEventListener('transitionend', driveUp);
        train.addEventListener('transitionend', driveDown);
    }

    const driveDown = e => {
        if (e && e.propertyName !== 'transform') return;
        train.style.setProperty('--train-position', startPosition);
        train.removeEventListener('transitionend', driveDown);
        train.addEventListener('transitionend', driveUp);
    }

    window.addEventListener('load', e => driveUp());
}
